import { Application, Controller } from '@hotwired/stimulus'

const application = Application.start()
application.debug = false
window.Stimulus = application

const context = require.context('./controllers', true, /_controller\.js$/, 'lazy')

context.keys().forEach((key) => {
  const identifier = key
    .replace(/^\.\//, '')
    .replace(/_controller\.js$/, '')
    .replace(/\//g, '--')
    .replace(/_/g, '-')

  application.register(identifier, class extends Controller {
    connect() {
      context(key).then((module) => {
        application.register(identifier, module.default)
      })
    }
  })
})
